module.exports = __webpack_public_path__ + "static/media/honda-bumper_selected.4be65243.svg";